(() => {
  if (window.CosmeauCartDrawer) return;

  window.CosmeauCartI18n = window.CosmeauCartI18n || (() => {
    const source = document.querySelector('[data-cosmeau-cart-i18n]');
    if (!source) return {};
    try { return JSON.parse(source.textContent || '{}'); }
    catch (error) { console.error('[CosmeauCart] invalid locale configuration', error); return {}; }
  })();
  const text = (key, variables = {}) => Object.entries(variables).reduce(
    (value, [name, replacement]) => value.replace(
      new RegExp(`{{\\s*${name}\\s*}}`, 'g'),
      String(replacement),
    ),
    String(window.CosmeauCartI18n[key] || ''),
  );
  const cartRoot = document.querySelector('cart-drawer[data-cosmeau-cart]');
  const marketRewardsEnabled = cartRoot?.dataset.cosmeauMarketRewardsEnabled === 'true';

  const SHEET_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/sheet_hand_8950fcdd-574d-4ce5-9dc8-d0799adec977.jpg?v=1721752078';
  const PEARL_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/all_scents_5b37ba63-0e1f-4e1e-a22e-7088970a5a7e.jpg?v=1715952341';
  const BOX_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/5_colored_full_655ada62-f56c-4cbb-9b91-05910a1439e9.jpg?v=1733820459';
  const CLOTH_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/1_hero_2.jpg?v=1749907015';
  const choice = (titleKey, variantId, imageUrl) => ({ titleKey, variantId, imageUrl });

  const fallbackConfig = {
    enabled: true,
    rewards: [
      { key: 'shipping-19', labelKey: 'reward_shipping', thresholdMinor: 1900, kind: 'shipping', choices: [] },
      { key: 'gift-strip-30', labelKey: 'reward_strip', thresholdMinor: 3000, kind: 'gift', choices: [
        choice('choice_wild_forest', '53950549786951', SHEET_IMAGE),
        choice('choice_lavender', '52541182443847', SHEET_IMAGE),
        choice('choice_sea_breeze', '49913394266439', SHEET_IMAGE),
        choice('choice_toilet_cleaner', '49913394430279', SHEET_IMAGE),
        choice('choice_floor_cleaner', '49913420841287', SHEET_IMAGE),
        choice('choice_dishwasher_tablets', '50379343135047', SHEET_IMAGE),
      ] },
      { key: 'gift-pearls-45', labelKey: 'reward_pearls', thresholdMinor: 4500, kind: 'gift', choices: [
        choice('choice_lavender', '49913416745287', PEARL_IMAGE),
        choice('choice_spring_fresh', '49913416319303', PEARL_IMAGE),
        choice('choice_wild_forest', '49913417138503', PEARL_IMAGE),
        choice('choice_sea_breeze', '49913416548679', PEARL_IMAGE),
        choice('choice_cherry_blossom', '49913416941895', PEARL_IMAGE),
        choice('choice_pure', '53272141660487', PEARL_IMAGE),
        choice('choice_autumn', '53391881339207', PEARL_IMAGE),
        choice('choice_clouds', '49913417335111', PEARL_IMAGE),
      ] },
      { key: 'gift-choice-90', labelKey: 'reward_choice', thresholdMinor: 9000, kind: 'gift', choices: [
        choice('choice_box_white', '48738117550407', BOX_IMAGE),
        choice('choice_box_black', '48738117583175', BOX_IMAGE),
        choice('choice_box_spring', '50710775464263', BOX_IMAGE),
        choice('choice_box_sea_breeze', '50710776447303', BOX_IMAGE),
        choice('choice_box_lavender', '50710778577223', BOX_IMAGE),
        choice('choice_box_cherry_blossom', '50710779822407', BOX_IMAGE),
        choice('choice_box_wild_forest', '50710779953479', BOX_IMAGE),
        choice('choice_box_clouds', '50710780576071', BOX_IMAGE),
        choice('choice_box_haarlem', '54271830720839', BOX_IMAGE),
        choice('choice_cloths_black', '52046579204423', CLOTH_IMAGE),
        choice('choice_cloths_purple', '52046579237191', CLOTH_IMAGE),
        choice('choice_cloths_blue', '52046579269959', CLOTH_IMAGE),
        choice('choice_cloths_green', '52046579302727', CLOTH_IMAGE),
        choice('choice_cloths_cherry_blossom', '52046579335495', CLOTH_IMAGE),
        choice('choice_cloths_delft_blue', '52046579368263', CLOTH_IMAGE),
      ] },
    ],
    upsells: [
      { key: 'scent-pearls', handle: 'geurparels-geurbooster-wasparfum', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
      { key: 'laundry-perfume', handle: 'wasparfum', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
      { key: 'machine-care-tablets', handle: 'wasmachine-diepreinigingstabletten', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
      { key: 'laundry-sheet-box', handle: 'wasstrips-bewaardoos-box', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
      { key: 'dryer-balls', handle: 'drogerballen-6-stuks-met-bewaardoos', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
    ],
  };

  const money = (minor) => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(minor / 100);
  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const plainProductText = (value) => {
    const parsed = new DOMParser().parseFromString(String(value || ''), 'text/html');
    return String(parsed.body.textContent || '').replace(/\s+/g, ' ').trim();
  };
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  let config = fallbackConfig;
  let syncing = false;
  let queuedCart = null;
  let renderedFingerprint = '';
  let pendingWasEmpty = false;
  let recommendationRun = 0;
  let recommendationAnchor = null;
  const recommendationProducts = new Map();

  const CURATED_LAUNDRY_HANDLES = [
    'geurparels-geurbooster-wasparfum',
    'wasparfum',
    'wasmachine-diepreinigingstabletten',
    'wasstrips-bewaardoos-box',
    'drogerballen-6-stuks-met-bewaardoos',
  ];


  function showPendingItem(product) {
    const root = document.querySelector('cart-drawer[data-cosmeau-cart]');
    const holder = root?.querySelector('#CartDrawer-CartItems');
    if (!root || !holder) return;
    clearPendingItem();
    pendingWasEmpty = root.classList.contains('is-empty');
    root.classList.toggle('pending-from-empty', pendingWasEmpty);
    root.classList.remove('is-empty');
    root.classList.add('is-cart-loading', 'has-pending-item');
    root.querySelector('cart-drawer-items')?.classList.remove('is-empty');
    const count = Math.max(1, Number(product?.quantity || 1));
    const image = product?.imageUrl
      ? `<img src="${escapeHtml(product.imageUrl)}" alt="" width="64" height="64">`
      : '<span class="cosmeau-cart__pending-placeholder" aria-hidden="true"></span>';
    const quantityCopy = count > 1 ? text('pending_quantity', { count }) : '';
    holder.insertAdjacentHTML('afterbegin', `<div class="cosmeau-cart__pending-item" data-cosmeau-pending-item role="status" aria-live="polite">${image}<span class="cosmeau-cart__pending-copy"><strong>${escapeHtml(product?.title || text('generic_product'))}</strong>${product?.variantTitle ? `<small>${escapeHtml(product.variantTitle)}</small>` : ''}<small>${escapeHtml(quantityCopy)}${escapeHtml(text('pending_add'))}</small></span><span class="cosmeau-cart__pending-spinner" aria-hidden="true"></span></div>`);
    const itemCount = root.querySelector('[data-cosmeau-cart-count]');
    if (itemCount && pendingWasEmpty) itemCount.textContent = text('pending_add');
  }

  function clearPendingItem(restoreEmpty = false) {
    const root = document.querySelector('cart-drawer[data-cosmeau-cart]');
    root?.querySelector('[data-cosmeau-pending-item]')?.remove();
    root?.classList.remove('has-pending-item', 'pending-from-empty', 'is-cart-loading');
    if (restoreEmpty && pendingWasEmpty) {
      root?.classList.add('is-empty');
      root?.querySelector('cart-drawer-items')?.classList.add('is-empty');
    }
    pendingWasEmpty = false;
  }

  async function fetchCart() {
    const response = await fetch(`${rootUrl()}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(text('cart_load_error'));
    return response.json();
  }

  const cartFingerprint = (cart) => JSON.stringify({
    count: cart.item_count,
    total: cart.total_price,
    discount: cart.total_discount,
    items: (cart.items || []).map((item) => [item.key, item.quantity, item.final_line_price, item.selling_plan_allocation?.selling_plan?.id || '']),
  });
  const isAutomaticRewardItem = (item) => Boolean(item?.properties?._cosmeau_auto_reward_key);
  const isLegacyRewardItem = (item) => Boolean(item?.properties?._cosmeau_reward_key);
  const isRewardItem = (item) => isAutomaticRewardItem(item) || isLegacyRewardItem(item);
  const eligibleTotal = (cart) => {
    const items = cart?.items || [];
    const totalAfterDiscounts = Number(cart?.total_price);
    if (Number.isFinite(totalAfterDiscounts)) {
      const rewardTotal = items.reduce(
        (sum, item) => sum + (isRewardItem(item) ? Number(item.final_line_price || 0) : 0),
        0
      );
      return Math.max(0, totalAfterDiscounts - rewardTotal);
    }
    return items.reduce(
      (sum, item) => sum + (isRewardItem(item) ? 0 : Number(item.final_line_price || 0)),
      0
    );
  };
  const nextReward = (total) => marketRewardsEnabled
    ? config.rewards.find((reward) => total < reward.thresholdMinor) || null
    : null;

  function progressPercent(total) {
    const thresholds = config.rewards.map((reward) => reward.thresholdMinor);
    const count = thresholds.length;
    if (!count || total <= 0) return 0;
    const reached = thresholds.filter((threshold) => total >= threshold).length;
    if (reached >= count) return 100;
    const lower = reached ? thresholds[reached - 1] : 0;
    const upper = thresholds[reached];
    const lowerPosition = reached ? ((reached - 0.5) / count) * 100 : 0;
    const upperPosition = ((reached + 0.5) / count) * 100;
    return lowerPosition + ((total - lower) / Math.max(1, upper - lower)) * (upperPosition - lowerPosition);
  }

  const selectedRewardKeys = (cart) => new Set((cart.items || []).filter(isAutomaticRewardItem).map((item) => item.properties._cosmeau_auto_reward_key));

  async function refreshSections(open = true) {
    const sectionUrl = `${rootUrl()}cart?sections=cart-drawer,cart-icon-bubble&_=${Date.now()}`;
    const [sectionsResponse, cart] = await Promise.all([
      fetch(sectionUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }),
      fetchCart(),
    ]);
    if (!sectionsResponse.ok) throw new Error(text('cart_refresh_error'));
    const sections = await sectionsResponse.json();
    const drawer = document.querySelector('cart-drawer[data-cosmeau-cart]');
    drawer?.patchDynamicRegions?.(sections['cart-drawer']);
    drawer?.patchCartIcon?.(sections['cart-icon-bubble']);
    await sync(cart);
    if (open) drawer?.open?.();
    else drawer?.close?.();
    document.dispatchEvent(new CustomEvent('cart_changed', { detail: { source: 'cosmeau-cart', cart } }));
    return cart;
  }

  const rewardThreshold = (item) => {
    const key = item?.properties?._cosmeau_auto_reward_key;
    const configured = config.rewards.find((reward) => reward.key === key)?.thresholdMinor;
    return Number(configured || item?.properties?._cosmeau_auto_reward_threshold || Number.MAX_SAFE_INTEGER);
  };

  async function removeInvalidRewards(cart, total) {
    const invalid = (cart.items || []).filter((item) => isLegacyRewardItem(item) || (isAutomaticRewardItem(item) && total < rewardThreshold(item)));
    if (!invalid.length) return null;
    const updates = Object.fromEntries(invalid.map((item) => [item.key, 0]));
    const response = await fetch(`${rootUrl()}cart/update.js`, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });
    const updated = await response.json();
    if (!response.ok || updated?.errors) throw new Error(updated?.description || updated?.errors || text('invalid_reward_remove_error'));
    const drawer = document.querySelector('cart-drawer[data-cosmeau-cart]');
    drawer?.patchDynamicRegions?.(updated.sections?.['cart-drawer']);
    drawer?.patchCartIcon?.(updated.sections?.['cart-icon-bubble']);
    return updated;
  }

  async function reconcileRewards(cart) {
    if (!cart || !Array.isArray(cart.items)) return cart;
    if (!marketRewardsEnabled) return cart;
    const total = eligibleTotal(cart);
    return await removeInvalidRewards(cart, total) || cart;
  }

  function renderRewards(root, cart, total) {
    const itemCount = Number.isFinite(Number(cart?.item_count))
      ? Number(cart.item_count)
      : (cart?.items || []).reduce((sum, item) => sum + Number(item?.quantity || 0), 0);
    const count = root.querySelector('[data-cosmeau-cart-count]');
    if (count) count.textContent = `${itemCount} ${text(itemCount === 1 ? 'item_one' : 'item_other')}`;
    document.querySelectorAll('.cosmeau-v6-header__cart-count').forEach((node) => { node.textContent = itemCount; });
    if (!marketRewardsEnabled) {
      const rewards = root.querySelector('[data-cosmeau-cart-rewards]');
      if (rewards) rewards.hidden = true;
      return;
    }
    const next = nextReward(total);
    const progress = root.querySelector('[data-cosmeau-cart-progress]');
    if (progress) {
      const percent = Math.min(100, Math.max(0, progressPercent(total)));
      progress.style.width = `${percent}%`;
      progress.dataset.progress = String(percent);
    }
    root.querySelectorAll('[data-threshold-minor]').forEach((node) => node.classList.toggle('is-reached', total >= Number(node.dataset.thresholdMinor)));
    const message = root.querySelector('[data-cosmeau-cart-next]');
    if (message) message.innerHTML = next
      ? text(next.kind === 'shipping' ? 'shipping_remaining_html' : 'gift_remaining_html', {
        amount: escapeHtml(money(next.thresholdMinor - total)),
      })
      : text('all_rewards_unlocked_html');

    const giftHolder = root.querySelector('[data-cosmeau-cart-gifts]');
    if (!giftHolder) return;
    const selected = selectedRewardKeys(cart);
    const available = config.rewards.find((reward) => reward.kind === 'gift' && total >= reward.thresholdMinor && !selected.has(reward.key) && reward.choices?.length);
    if (!available) { giftHolder.innerHTML = ''; return; }
    const choices = available.choices.map((item) => `<button class="cosmeau-cart__gift" type="button" data-cosmeau-gift data-key="${escapeHtml(available.key)}" data-threshold="${available.thresholdMinor}" data-variant="${escapeHtml(item.variantId)}"><img src="${escapeHtml(item.imageUrl)}" alt="" width="70" height="70" loading="lazy"><span>${escapeHtml(text(item.titleKey))}</span></button>`).join('');
    const choiceCount = text(available.choices.length === 1 ? 'choice_one' : 'choice_other', { count: available.choices.length });
    giftHolder.innerHTML = `<div class="cosmeau-cart__gift-panel" data-reward-key="${escapeHtml(available.key)}"><div class="cosmeau-cart__gift-heading"><p class="cosmeau-cart__gift-title">${escapeHtml(text(available.labelKey))}, ${escapeHtml(text('gift_choose'))} <span>${escapeHtml(choiceCount)}</span></p><div class="cosmeau-cart__gift-arrows"><button type="button" data-cosmeau-gift-scroll="-1" aria-label="${escapeHtml(text('previous_gifts'))}">‹</button><button type="button" data-cosmeau-gift-scroll="1" aria-label="${escapeHtml(text('more_gifts'))}">›</button></div></div><div class="cosmeau-cart__gift-choices" data-cosmeau-gift-track>${choices}</div></div>`;
  }

  function normalizeRecommendedProduct(product) {
    if (!product?.handle) return null;
    const variants = (product.variants || []).filter((variant) => variant.available !== false).map((variant) => ({
      id: Number(variant.id),
      title: String(variant.title || text('default_variant')),
      price: Number(variant.price || 0),
    })).filter((variant) => variant.id);
    if (!variants.length) return null;
    const rawImage = product.featured_image?.src || product.featured_image || product.images?.[0]?.src || product.images?.[0] || '';
    return {
      id: Number(product.id || 0),
      handle: String(product.handle),
      title: String(product.title || ''),
      type: String(product.type || ''),
      tags: Array.isArray(product.tags) ? product.tags : [],
      imageUrl: String(rawImage).startsWith('//') ? `https:${rawImage}` : String(rawImage),
      descriptionHtml: String(product.description || product.body_html || ''),
      shortDescription: plainProductText(product.description || product.body_html).slice(0, 160),
      variants,
      priceMinor: Math.min(...variants.map((variant) => variant.price)),
    };
  }

  async function fetchProduct(handle) {
    const cached = recommendationProducts.get(handle);
    if (cached) return cached;
    const response = await fetch(`${rootUrl()}products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin', cache: 'force-cache', headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    const product = normalizeRecommendedProduct(await response.json());
    if (product) recommendationProducts.set(product.handle, product);
    return product;
  }

  async function fetchComplementary(productId) {
    if (!productId) return [];
    const query = new URLSearchParams({ product_id: String(productId), limit: '8', intent: 'complementary' });
    const response = await fetch(`${rootUrl()}recommendations/products.json?${query}`, {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' },
    });
    if (!response.ok) return [];
    const data = await response.json();
    return (data.products || []).map(normalizeRecommendedProduct).filter(Boolean);
  }

  const isLaundryRecommendation = (product) => {
    const haystack = `${product.type} ${(product.tags || []).join(' ')} ${product.handle}`.toLowerCase();
    return /(laundry|wasparfum|wasmachine|wasstrips|scent|geurparel|dryer|droger)/.test(haystack)
      && !/(dishwasher|vaatwas|cleaning tab)/.test(haystack);
  };

  function recommendationAnchorItem(cartItems) {
    if (!cartItems.length) {
      recommendationAnchor = null;
      return null;
    }
    const existing = recommendationAnchor
      ? cartItems.find((item) => Number(item.product_id) === Number(recommendationAnchor.product_id))
      : null;
    if (existing) return existing;
    const core = cartItems.find((item) => /^(wasmiddel-wasstrips-g6|wasmiddel-wasstrips)$/.test(String(item.handle || '')));
    const anchor = core || cartItems[cartItems.length - 1];
    recommendationAnchor = { product_id: anchor?.product_id, handle: anchor?.handle };
    return anchor;
  }

  async function recommendationSet(cart) {
    const cartItems = (cart.items || []).filter((item) => !isRewardItem(item));
    const anchor = recommendationAnchorItem(cartItems);
    const cartHandles = new Set(cartItems.map((item) => item.handle));
    const triggerHandles = new Set(cartHandles);
    const configured = (config.upsells || []).filter((item) => !item.triggerHandles?.length || item.triggerHandles.some((handle) => triggerHandles.has(handle)));
    const curatedHandles = configured.map((item) => item.handle).filter(Boolean);
    const laundryCart = /(wasmiddel|wasstrip|wasparfum|geurparel|droger|laundry)/i.test(`${anchor?.handle || ''} ${anchor?.product_type || ''}`);
    const preferredHandles = curatedHandles.length ? curatedHandles : (laundryCart ? CURATED_LAUNDRY_HANDLES : []);
    const [curated, complementary] = await Promise.all([
      Promise.all(preferredHandles.map(fetchProduct)),
      fetchComplementary(anchor?.product_id),
    ]);
    const result = [];
    const seen = new Set(anchor?.handle ? [anchor.handle] : []);
    const relevantComplementary = laundryCart ? complementary.filter(isLaundryRecommendation) : complementary;
    [...curated.filter(Boolean), ...relevantComplementary].forEach((product) => {
      if (!product || seen.has(product.handle) || result.length >= 8) return;
      seen.add(product.handle);
      recommendationProducts.set(product.handle, product);
      result.push(product);
    });
    return result;
  }

  async function renderUpsell(root, cart) {
    const section = root.querySelector('[data-cosmeau-cart-upsell]');
    const holder = root.querySelector('[data-cosmeau-cart-upsell-content]');
    if (!section || !holder) return;
    const previousScroll = holder.querySelector('[data-cosmeau-upsell-track]')?.scrollLeft || 0;
    const run = ++recommendationRun;
    let products = [];
    try { products = await recommendationSet(cart); }
    catch (error) { console.warn('[CosmeauCart] recommendations unavailable', error); }
    if (run !== recommendationRun) return;
    if (!products.length) { section.hidden = true; holder.innerHTML = ''; return; }
    const cards = products.map((product) => {
      const priceLabel = product.variants.length === 1 ? money(product.priceMinor) : text('from_price', { price: money(product.priceMinor) });
      const image = product.imageUrl
        ? `<img src="${escapeHtml(product.imageUrl)}" alt="" width="64" height="64" loading="lazy">`
        : '<span class="cosmeau-cart__upsell-image-placeholder" aria-hidden="true"></span>';
      return `<button type="button" class="cosmeau-cart__upsell-card" data-cosmeau-upsell-product="${escapeHtml(product.handle)}" aria-label="${escapeHtml(text('choose_product', { product: product.title }))}">${image}<span class="cosmeau-cart__upsell-copy"><span class="cosmeau-cart__upsell-title">${escapeHtml(product.title)}</span><span class="cosmeau-cart__upsell-price">${escapeHtml(priceLabel)}</span></span></button>`;
    }).join('');
    holder.innerHTML = `<div class="cosmeau-cart__upsell-track" data-cosmeau-upsell-track>${cards}</div>`;
    const nextTrack = holder.querySelector('[data-cosmeau-upsell-track]');
    if (nextTrack && previousScroll) requestAnimationFrame(() => { nextTrack.scrollLeft = previousScroll; });
    section.hidden = false;
  }

  function renderMiniPdp(scope, product) {
    const api = window.CosmeauProductSnapshot;
    const locale = (document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
    const resolved = api?.resolveSnapshot({
      productId: product.id,
      productHandle: product.handle,
      descriptionHtml: product.descriptionHtml || '',
      locale,
    }) || { benefits: [], icons: [], topics: [], summary: product.shortDescription || '' };
    const benefits = scope?.querySelector('[data-cosmeau-mini-pdp-benefits]');
    const accordion = scope?.querySelector('[data-cosmeau-mini-pdp-accordion]');

    if (benefits) {
      benefits.replaceChildren();
      resolved.benefits.slice(0, 4).forEach((text, index) => {
        const item = document.createElement('div');
        item.className = 'cosmeau-cart__mini-pdp-benefit';
        const icon = document.createElement('span');
        icon.className = 'cosmeau-cart__mini-pdp-benefit-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = resolved.icons[index] || '✅';
        const copy = document.createElement('span');
        copy.textContent = text;
        item.append(icon, copy);
        benefits.append(item);
      });
      benefits.hidden = !resolved.benefits.length;
    }

    if (accordion) {
      accordion.replaceChildren();
      const topics = resolved.topics.length
        ? resolved.topics
        : (product.shortDescription ? [{ title: text('product_description'), text: product.shortDescription }] : []);
      topics.slice(0, 4).forEach((topic, index) => {
        const details = document.createElement('details');
        details.className = 'cosmeau-cart__mini-pdp-topic';
        details.open = index === 0;
        const summary = document.createElement('summary');
        summary.textContent = topic.title || text('product_description');
        const body = document.createElement('p');
        body.textContent = topic.text;
        details.append(summary, body);
        accordion.append(details);
      });
      accordion.hidden = !topics.length;
    }
    return resolved;
  }

  function focusableSheetElements(sheet) {
    if (!sheet) return [];
    const selector = [
      'a[href]',
      'button:not([disabled])',
      'summary',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');
    return [...sheet.querySelectorAll(selector)].filter((element) => {
      const style = window.getComputedStyle(element);
      return !element.hidden && style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
  }

  function trapSheetFocus(event, sheet) {
    if (event.key !== 'Tab' || !sheet) return;
    const focusable = focusableSheetElements(sheet);
    if (!focusable.length) {
      event.preventDefault();
      sheet.setAttribute('tabindex', '-1');
      sheet.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || !sheet.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !sheet.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  function closeVariantSheet() {
    const sheet = document.querySelector('[data-cosmeau-variant-sheet]');
    if (!sheet) return;
    sheet.hidden = true;
    sheet.querySelector('[data-cosmeau-variant-options]').innerHTML = '';
    document.querySelector('cart-drawer[data-cosmeau-cart]')?.classList.remove('is-variant-sheet-open');
  }

  function openProductSheet(trigger) {
    const root = document.querySelector('[data-cosmeau-cart]');
    const sheet = document.querySelector('[data-cosmeau-product-sheet]');
    if (!sheet || !trigger) return;
    const title = sheet.querySelector('[data-cosmeau-product-title]');
    const option = sheet.querySelector('[data-cosmeau-product-option]');
    const desc = sheet.querySelector('[data-cosmeau-product-desc]');
    const price = sheet.querySelector('[data-cosmeau-product-price]');
    const link = sheet.querySelector('[data-cosmeau-product-link]');
    if (title) title.textContent = trigger.dataset.infoTitle || '';
    if (option) option.textContent = trigger.dataset.infoOpt ? text('variant_label', { variant: trigger.dataset.infoOpt }) : '';
    const descriptionHtml = trigger.closest('.cart-item')?.querySelector('[data-cosmeau-product-description-source]')?.value || '';
    const product = {
      id: Number(trigger.dataset.infoProductId || 0),
      handle: trigger.dataset.infoHandle || '',
      descriptionHtml,
      shortDescription: trigger.dataset.infoDesc || '',
    };
    const resolved = renderMiniPdp(sheet, product);
    if (desc) desc.textContent = resolved.summary || product.shortDescription;
    if (price) price.textContent = trigger.dataset.infoPrice || '';
    if (link) {
      link.href = trigger.dataset.infoUrl || '#';
      link.hidden = !trigger.dataset.infoUrl;
    }
    const imageSrc = trigger.dataset.infoImage;
    const imgEl = sheet.querySelector('#CosmeauProductSheetImage');
    if (imgEl) {
      if (imageSrc) { imgEl.src = imageSrc; imgEl.hidden = false; }
      else { imgEl.removeAttribute('src'); imgEl.hidden = true; }
    }
    sheet.hidden = false;
    sheet._returnFocus = trigger;
    root?.classList.add('is-product-sheet-open');
    sheet.querySelector('[data-cosmeau-product-close]')?.focus();
  }

  function closeProductSheet() {
    const sheet = document.querySelector('[data-cosmeau-product-sheet]');
    if (!sheet) return;
    sheet.hidden = true;
    document.querySelector('cart-drawer[data-cosmeau-cart]')?.classList.remove('is-product-sheet-open');
  }

  function openVariantSheet(product, returnFocus) {
    const sheet = document.querySelector('[data-cosmeau-variant-sheet]');
    const title = sheet?.querySelector('[data-cosmeau-variant-title]');
    const image = sheet?.querySelector('[data-cosmeau-variant-image]');
    const description = sheet?.querySelector('[data-cosmeau-variant-description]');
    const price = sheet?.querySelector('[data-cosmeau-variant-price]');
    const options = sheet?.querySelector('[data-cosmeau-variant-options]');
    if (!sheet || !title || !options) return;
    title.textContent = product.title;
    if (image) {
      image.src = product.imageUrl || '';
      image.alt = product.title || '';
      image.hidden = !product.imageUrl;
    }
    const resolved = renderMiniPdp(sheet, product);
    if (description) description.textContent = resolved.summary || product.shortDescription || text('upsell_fallback');
    if (price) price.textContent = product.variants.length > 1 ? text('from_price', { price: money(product.priceMinor) }) : money(product.priceMinor);
    options.innerHTML = product.variants.map((variant) => {
      const label = product.variants.length === 1 || variant.title === 'Default Title' ? text('add_to_cart') : variant.title;
      return `<button type="button" data-cosmeau-upsell-variant="${variant.id}" data-cosmeau-upsell-handle="${escapeHtml(product.handle)}"><span>${escapeHtml(label)}</span><strong>${escapeHtml(money(variant.price))}</strong></button>`;
    }).join('');
    sheet.hidden = false;
    sheet._returnFocus = returnFocus;
    document.querySelector('cart-drawer[data-cosmeau-cart]')?.classList.add('is-variant-sheet-open');
    sheet.querySelector('[data-cosmeau-upsell-variant]')?.focus();
  }


  async function addItems(items) {
    const drawer = document.querySelector('cart-drawer[data-cosmeau-cart]');
    const payload = { items };
    if (drawer?.getSectionsToRender) {
      payload.sections = drawer.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }
    const response = await fetch(`${rootUrl()}cart/add.js`, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok || data?.status) throw new Error(data?.description || text('product_add_error'));
    if (drawer?.renderContents && data.sections) drawer.renderContents(data);
    else await refreshSections();
    const cart = await fetchCart();
    await sync(cart);
    document.dispatchEvent(new CustomEvent('cart_changed', { detail: { source: 'cosmeau-cart', cart } }));
    return { data, cart };
  }

  async function addGift(button) {
    button.disabled = true;
    try {
      const cart = await fetchCart();
      const total = eligibleTotal(cart);
      const threshold = Number(button.dataset.threshold);
      const rewardKey = button.dataset.key;
      if (!marketRewardsEnabled || total < threshold || selectedRewardKeys(cart).has(rewardKey)) throw new Error(text('reward_unavailable'));
      await addItems([{ id: Number(button.dataset.variant), quantity: 1, properties: { _cosmeau_auto_reward_key: rewardKey, _cosmeau_auto_reward_threshold: String(threshold) } }]);
    } catch (error) {
      console.error('[CosmeauCart] gift add failed', error);
      button.disabled = false;
      button.textContent = text('retry');
    }
  }

  async function addUpsell(button, variantId) {
    if (!button || !variantId) return;
    button.disabled = true;
    button.classList.add('is-adding');
    button.setAttribute('aria-busy', 'true');
    try {
      await addItems([{ id: Number(variantId), quantity: 1 }]);
      closeVariantSheet();
    } catch (error) {
      console.error('[CosmeauCart] upsell add failed', error);
      button.disabled = false;
      button.classList.remove('is-adding');
      button.removeAttribute('aria-busy');
      window.CosmeauCartNotice?.show?.(text('not_added'), error.message || text('retry'));
    }
  }

  async function changeLinePlan(select) {
    const drawer = document.querySelector('cart-drawer[data-cosmeau-cart]');
    const previous = select.dataset.previousValue ?? select.querySelector('option[selected]')?.value ?? '';
    const planId = String(select.value || '').trim();
    let properties = {};
    try {
      const parsedProperties = JSON.parse(select.dataset.lineProperties || '{}') || {};
      properties = Array.isArray(parsedProperties) ? Object.fromEntries(parsedProperties) : parsedProperties;
    } catch (_) {}
    properties._selling_plan_id = '';
    select.disabled = true;
    select.closest('.cart-item')?.classList.add('is-updating-plan');
    try {
      const response = await fetch(`${rootUrl()}cart/change.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(select.dataset.lineIndex || 1),
          quantity: Number(select.dataset.quantity || 1),
          selling_plan: planId || null,
          properties,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state?.errors) throw new Error(state?.description || state?.errors || text('purchase_type_error'));
      const updatedItem = state.items?.[Math.max(0, Number(select.dataset.lineIndex || 1) - 1)];
      const appliedPlan = String(updatedItem?.selling_plan_allocation?.selling_plan?.id || '');
      if (appliedPlan !== planId) throw new Error(text('plan_save_error'));
      drawer?.renderContents?.(state);
      await sync(state);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cosmeau-cart-plan', cartData: state });
      document.dispatchEvent(new CustomEvent('cart_changed', { detail: { source: 'cosmeau-cart-plan', cart: state } }));
    } catch (error) {
      console.error('[CosmeauCart] plan change failed', error);
      select.value = previous;
      select.disabled = false;
      select.closest('.cart-item')?.classList.remove('is-updating-plan');
    }
  }

  async function sync(cart) {
    if (syncing) { if (cart) queuedCart = cart; return; }
    const root = document.querySelector('[data-cosmeau-cart]');
    if (!root) return;
    syncing = true;
    try {
      let currentCart = cart || await fetchCart();
      const fingerprint = cartFingerprint(currentCart);
      if (fingerprint === renderedFingerprint) return currentCart;
      currentCart = await reconcileRewards(currentCart);
      const total = eligibleTotal(currentCart);
      root.classList.toggle('is-empty', currentCart.item_count === 0);
      renderRewards(root, currentCart, total);
      await renderUpsell(root, currentCart);
      renderedFingerprint = cartFingerprint(currentCart);
      return currentCart;
    } catch (error) { console.error('[CosmeauCart] sync failed', error); }
    finally {
      syncing = false;
      if (queuedCart) {
        const next = queuedCart;
        queuedCart = null;
        queueMicrotask(() => sync(next));
      }
    }
  }

  function mergeRemoteConfig(remote) {
    if (!remote?.enabled || !Array.isArray(remote.rewards) || !Array.isArray(remote.upsells)) return;
    const remoteByKey = new Map(remote.rewards.map((reward) => [reward.key, reward]));
    config = {
      enabled: true,
      rewards: fallbackConfig.rewards.map((fallback) => {
        const current = remoteByKey.get(fallback.key);
        if (!current) return fallback;
        const choices = new Map(fallback.choices.map((item) => [String(item.variantId), item]));
        (current.choices || []).forEach((item) => {
          const previous = choices.get(String(item.variantId));
          if (!previous) return;
          choices.set(String(item.variantId), { ...previous, ...item });
        });
        return { ...fallback, ...current, choices: Array.from(choices.values()) };
      }),
      upsells: remote.upsells,
    };
  }

  async function loadConfig() {
    if (!marketRewardsEnabled) return;
    const root = document.querySelector('[data-cosmeau-cart]');
    const url = root?.dataset.configUrl;
    if (!url) return;
    try {
      const response = await fetch(url, { mode: 'cors', credentials: 'omit', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const data = await response.json();
      mergeRemoteConfig(data?.config);
    } catch (error) { console.warn('[CosmeauCart] using safe embedded config', error); }
  }

  document.addEventListener('click', (event) => {
    const discountInfoToggle = event.target.closest('[data-cosmeau-discount-info-toggle]');
    if (discountInfoToggle) {
      event.preventDefault();
      const info = discountInfoToggle.parentElement?.querySelector('[data-cosmeau-discount-info]');
      const expanded = discountInfoToggle.getAttribute('aria-expanded') === 'true';
      discountInfoToggle.setAttribute('aria-expanded', String(!expanded));
      if (info) info.hidden = expanded;
      return;
    }
    const gift = event.target.closest('[data-cosmeau-gift]');
    if (gift) { event.preventDefault(); addGift(gift); return; }
    const scroll = event.target.closest('[data-cosmeau-gift-scroll]');
    if (scroll) {
      event.preventDefault();
      const track = scroll.closest('.cosmeau-cart__gift-panel')?.querySelector('[data-cosmeau-gift-track]');
      track?.scrollBy({ left: Number(scroll.dataset.cosmeauGiftScroll) * Math.max(180, track.clientWidth * .78), behavior: 'smooth' });
      return;
    }
    const closeSheet = event.target.closest('[data-cosmeau-variant-close]');
    if (closeSheet) {
      event.preventDefault();
      const sheet = closeSheet.closest('[data-cosmeau-variant-sheet]');
      const returnFocus = sheet?._returnFocus;
      closeVariantSheet();
      returnFocus?.focus?.();
      return;
    }
    const productTrigger = event.target.closest('[data-cosmeau-product-info-trigger]');
    if (productTrigger) {
      event.preventDefault();
      openProductSheet(productTrigger);
      return;
    }
    const closeProduct = event.target.closest('[data-cosmeau-product-close]');
    if (closeProduct) {
      event.preventDefault();
      const returnFocus = closeProduct.closest('[data-cosmeau-product-sheet]')?._returnFocus;
      closeProductSheet();
      returnFocus?.focus?.();
      return;
    }
    const variant = event.target.closest('[data-cosmeau-upsell-variant]');
    if (variant) {
      event.preventDefault();
      addUpsell(variant, variant.dataset.cosmeauUpsellVariant);
      return;
    }
    const upsell = event.target.closest('[data-cosmeau-upsell-product]');
    if (upsell) {
      event.preventDefault();
      const product = recommendationProducts.get(upsell.dataset.cosmeauUpsellProduct);
      if (!product) return;
      openVariantSheet(product, upsell);
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-cosmeau-plan-select]');
    if (!select) return;
    select.dataset.previousValue = select.querySelector('option[selected]')?.value || '';
    changeLinePlan(select);
  });
  document.addEventListener('keydown', (event) => {
    const activeSheet = document.querySelector('[data-cosmeau-variant-sheet]:not([hidden]), [data-cosmeau-product-sheet]:not([hidden])');
    if (event.key === 'Tab' && activeSheet) {
      trapSheetFocus(event, activeSheet);
      return;
    }
    if (event.key !== 'Escape') return;
    const sheet = document.querySelector('[data-cosmeau-variant-sheet]:not([hidden])');
    if (sheet) {
      const returnFocus = sheet._returnFocus;
      closeVariantSheet();
      returnFocus?.focus?.();
      return;
    }
    const productSheet = document.querySelector('[data-cosmeau-product-sheet]:not([hidden])');
    if (productSheet) {
      const returnFocus = productSheet._returnFocus;
      closeProductSheet();
      returnFocus?.focus?.();
    }
  });
  document.addEventListener('cart:refresh', () => refreshSections(true).catch((error) => console.error('[CosmeauCart] section refresh failed', error)));
  document.addEventListener('cart_changed', (event) => { if (event.detail?.source !== 'cosmeau-cart') sync(event.detail?.cart); });
  document.addEventListener('cart:updated', (event) => sync(event.detail?.cart));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => sync(event.cartData));
  }

  window.CosmeauCartDrawer = { sync, refreshSections, nextReward, eligibleTotal, progressPercent, changeLinePlan, reconcileRewards, showPendingItem, clearPendingItem, openProductSheet, closeProductSheet };
  loadConfig().finally(() => sync());
})();
